import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './assets/styles-enhanced.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.mount('#app');

// Web Vitals logging (optional, kept for performance monitoring)
if (import.meta.env.PROD && 'PerformanceObserver' in window) {
  try {
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        console.log(`[Web Vital] ${entry.name}:`, entry.startTime);
      });
    });
    observer.observe({ type: 'paint', buffered: true });
  } catch (e) {
    console.warn('PerformanceObserver failed:', e);
  }
}
